import { Loading } from "views/components/Loaders/Loading";
import { useDispatch } from "reactn";
import { useHistory } from "react-router";
import { useQuery } from "hooks/useQuery";
import React, { useEffect } from "react";
import jwtDecode from "jwt-decode";

export const AuthRedirect = () => {
	const query = useQuery();
	const history = useHistory();
	const doLoginWithUserData = useDispatch("doLoginWithUserData");

	useEffect(() => {
		if (!query.get("code")) {
			history.push("/");
			return;
		}
		try {
			const token = query.get("code");
			const data = jwtDecode(token);
			doLoginWithUserData({ data: { ...data.user, token } });
			history.push("/central");
		} catch (error) {
			history.push("/");
		}

		return () => {
			console.log("unmounting");
		};
	}, [doLoginWithUserData, history, query]);

	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				height: "100%",
			}}
		>
			<Loading />
		</div>
	);
};
